// CAROUSEL
function initCarousel($carousel,prevBtId,nextBtId) {
	$carousel.slick({
		slide: 'li',
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: jQuery(prevBtId),
		nextArrow: jQuery(nextBtId),
		draggable: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		infinite: true
	});
}

function initCarousels() {

	// Intiailize carousels
	jQuery('.carouselContainer').each(function(index){

		// Carousel data
		carouselContainer = jQuery(this);
		carousel = carouselContainer.find('.carouselList');
		prevBtId = carousel.attr("data-prevBt");
		nextBtId = carousel.attr("data-nextBt");

		// Init carousel
		initCarousel(carousel,prevBtId,nextBtId);
	});

}

function initCarouselHome() {

	// Intiailize carousel home
	jQuery('.carouselListHome').each(function(index){
		// Init carousel
		$carousel = jQuery(this);

		$carousel.on("beforeChange",function(event, slick, currentSlide, nextSlide){
			nextSlideElement = jQuery(slick.$slides.get(nextSlide));
			nextSlideElement.find(".imageDiv").css("webkitAnimation","none");

		});

		$carousel.on("afterChange",function(event, slick, currentSlide){
			currentSlideElement = jQuery(slick.$slides.get(currentSlide));
			currentSlideElement.find(".imageDiv").css("webkitAnimation","");
		});

		$carousel.slick({
			slide: 'li',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			fade: true,
			speed: 2000,
			draggable: false,
			infinite: true,
			lazyLoad: 'progressive'
		});

	});

}

(function(w, d){
	// Intiailize carousels
	initCarousels();
	initCarouselHome();

}(window, document));